export const inheritData = (array, dataInherit, data) => {
    if (!Array.isArray(array)) return []

    return array.map(item => {
        const updatedItem = { ...item }

        for (const [targetKey, sourceKey] of Object.entries(dataInherit)) {
            if (data && data[sourceKey] !== undefined) {
                updatedItem[targetKey] = data[sourceKey]
            }
        }

        return updatedItem
    })
}